const ApplicationName = 'StoreInt'
const ShopPermissionName = 'Order Express';
const ShopPermissionDisplayName = 'Telstra Connect shop';
const PlatformService = 'Platform';
const ApplicationNameForStoreServices = 'StoreInt'
const MicrosoftCspPex ='Microsoft CSP PEX'

const Links = Object.freeze({
  selfServiceStore:'StoreInt Tile Clicked',
  clickedOnTrackOrders: 'Clicked on active orders from shop tile',
  orderMoreBtn: 'Clicked on order more button on cart page',
  
  topMenuBarBtn: "Shop Top Menu Bar Button Clicked",
  accessTCTileBtn: "Access Telstra Connect Shop Button Clicked",
  arrowTileBtn: "Arrow Tile Button Clicked",
  
  networksCard: "Network Card Clicked",
  orderCrossConnectBtn: "Order Cross Connect Button Clicked",
  interestedLetsConnectBtn: "Interested Let's Connect Button Clicked",
  addToOrderBtn : "Add To Order Button Clicked",
  checkoutBtn: "Checkout Button Clicked",
  submitOrderBtn: "Submit Order Button Clicked"
});

const Components = Object.freeze({
  shopDashboardPage: "Shop-Int: Dashboard Page",
  shopNetworkLandingPage: "Shop-Int: Networks landing page",
  shopProductLandingPage: "Shop-Int: Products landing page",
  shopReviewAndConfirmPage: "Shop-Int: Review and confirm page",
  shopOrderSummaryPage: "Shop-Int: Order summary page",
  shopCheckoutPage: "Shop-Int: Checkout page",
});

export {ApplicationName, ApplicationNameForStoreServices, Links, Components, ShopPermissionName, ShopPermissionDisplayName, PlatformService, MicrosoftCspPex}
